// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Card shell ───────────────────────────────────────────── */

.scl--cms-components-notifTable-card {
  box-sizing: border-box;
  width: 100%;
  min-height: 100%;
  background: var(--neutralcolors-100);
  border: 1px solid var(--neutralcolors-300);
  box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.04);
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  min-width: 0;
}

/* ── Header ───────────────────────────────────────────────── */

.scl--cms-components-notifTable-header {
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 16px 24px;
  height: 56px;
  background: var(--neutralcolors-100);
  border-bottom: 1px solid var(--neutralcolors-300);
  flex-shrink: 0;
}

.scl--cms-components-notifTable-title {
  background: none;
  border: none;
  padding: 5px 20px 5px 0px;
  cursor: pointer;
  font-family: var(--font-family-inter);
  font-weight: 600;
  font-size: var(--font-size-18);
  line-height: var(--line-height-24);
  letter-spacing: var(--letter-spacing-6);
  color: var(--typography-text-body-primary);
  text-align: left;
}

.scl--cms-components-notifTable-title:hover {
  text-decoration: underline;
}

.scl--cms-components-notifTable-seeMore {
  font-family: var(--font-family-inter);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-14);
  line-height: var(--line-height-20);
  letter-spacing: var(--letter-spacing-4);
  color: var(--primarypalette-blue);
  text-decoration: none;
  white-space: nowrap;
  flex-shrink: 0;
}

.scl--cms-components-notifTable-seeMore:hover {
  text-decoration: underline;
}

/* ── Column headers ───────────────────────────────────────── */

.scl--cms-components-notifTable-thead {
  display: flex;
  flex-direction: row;
  align-items: center;
  background: var(--neutralcolors-200);
  border-bottom: 1px solid var(--neutralcolors-300);
  height: 34px;
  flex-shrink: 0;
}

.scl--cms-components-notifTable-th {
  font-family: var(--font-family-inter);
  font-weight: 500;
  font-size: var(--font-size-16);
  line-height: var(--line-height-18);
  letter-spacing: var(--letter-spacing-4);
  color: var(--neutralcolors-600);
  padding: 0 24px;
}

.scl--cms-components-notifTable-th--date {
  width: 145px;
  flex-shrink: 0;
}

/* ── Body ─────────────────────────────────────────────────── */

.scl--cms-components-notifTable-body {
  height: 362.5px;
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow-y: hidden;
}

/* ── Row ─────────────────────────────────────────────────── */

.scl--cms-components-notifTable-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  min-height: 80px;
  border-bottom: 1px solid var(--neutralcolors-300);
  box-sizing: border-box;
}

.scl--cms-components-notifTable-row:last-child {
  border-bottom: none;
}

.scl--cms-components-notifTable-row:hover {
  background: var(--action-hover);
}

/* ── Cells ───────────────────────────────────────────────── */

.scl--cms-components-notifTable-cell {
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 100%;
}

.scl--cms-components-notifTable-cell--date {
  width: 145px;
  flex-shrink: 0;
  padding: 12px 24px;
}

.scl--cms-components-notifTable-cell--desc {
  flex: 1;
  padding: 12px 24px;
  min-width: 0;
}

/* ── Date text ───────────────────────────────────────────── */

.scl--cms-components-notifTable-date {
  font-family: var(--font-family-inter);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-16);
  line-height: var(--line-height-30);
  color: var(--neutralcolors-600);
  white-space: nowrap;
}

/* ── Notification text ───────────────────────────────────── */

.scl--cms-components-notifTable-text {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 5px;
  flex: 1;
  min-width: 0;
}

.scl--cms-components-notifTable-notifTitle {
  background: transparent;
  border: none;
  display: flex;

  font-family: var(--font-family-inter);
  font-weight: 500;
  font-size: var(--font-size-16);
  line-height: var(--line-height-20);
  color: var(--neutralcolors-800);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  transition: all 0.3s ease;
  padding: 0;

}

.scl--cms-components-notifTable-notifTitle:hover {
  text-decoration: underline;
  cursor: pointer;
}

.scl--cms-components-notifTable-notifDesc {
  font-family: var(--font-family-inter);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-12);
  line-height: var(--line-height-18);
  color: var(--neutralcolors-600);
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
/* ── Skeleton loader ──────────────────────────────────────── */

@keyframes scl--cms-components-notifTable-shimmer {
  0%   { background-position: -600px 0; }
  100% { background-position:  600px 0; }
}

.scl--cms-components-notifTable-skeleton {
  background: linear-gradient(
    90deg,
    var(--neutralcolors-200) 25%,
    var(--neutralcolors-300) 50%,
    var(--neutralcolors-200) 75%
  );
  background-size: 600px 100%;
  animation: scl--cms-components-notifTable-shimmer 1.4s infinite linear;
  border-radius: 4px;
}

.scl--cms-components-notifTable-skeleton--title {
  width: 110px;
  height: 18px;
}

.scl--cms-components-notifTable-skeleton--link {
  width: 56px;
  height: 14px;
}

.scl--cms-components-notifTable-skeleton--th {
  height: 12px;
  border-radius: 3px;
}

.scl--cms-components-notifTable-skeleton--date {
  width: 72px;
  height: 14px;
}

.scl--cms-components-notifTable-skeleton--row-title {
  height: 14px;
  margin-bottom: 8px;
}

.scl--cms-components-notifTable-skeleton--row-desc {
  height: 12px;
  border-radius: 3px;
}`, "",{"version":3,"sources":["webpack://./src/component-controller-mod/component-serv/dashboard-fs-cp/notification-dsb-op/notification-table/css/notificationTable.css"],"names":[],"mappings":"AAAA,gEAAgE;;AAEhE;EACE,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,oCAAoC;EACpC,0CAA0C;EAC1C,8CAA8C;EAC9C,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,YAAY;AACd;;AAEA,gEAAgE;;AAEhE;EACE,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,YAAY;EACZ,oCAAoC;EACpC,iDAAiD;EACjD,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,yBAAyB;EACzB,eAAe;EACf,qCAAqC;EACrC,gBAAgB;EAChB,8BAA8B;EAC9B,kCAAkC;EAClC,uCAAuC;EACvC,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,qCAAqC;EACrC,uCAAuC;EACvC,8BAA8B;EAC9B,kCAAkC;EAClC,uCAAuC;EACvC,iCAAiC;EACjC,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,gEAAgE;;AAEhE;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,oCAAoC;EACpC,iDAAiD;EACjD,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,gBAAgB;EAChB,8BAA8B;EAC9B,kCAAkC;EAClC,uCAAuC;EACvC,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA,gEAAgE;;AAEhE;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,OAAO;EACP,kBAAkB;AACpB;;AAEA,+DAA+D;;AAE/D;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,iDAAiD;EACjD,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;AACjC;;AAEA,+DAA+D;;AAE/D;EACE,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,OAAO;EACP,kBAAkB;EAClB,YAAY;AACd;;AAEA,+DAA+D;;AAE/D;EACE,qCAAqC;EACrC,uCAAuC;EACvC,8BAA8B;EAC9B,kCAAkC;EAClC,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA,+DAA+D;;AAE/D;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;EACR,OAAO;EACP,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,aAAa;;EAEb,qCAAqC;EACrC,gBAAgB;EAChB,8BAA8B;EAC9B,kCAAkC;EAClC,+BAA+B;EAC/B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,yBAAyB;EACzB,UAAU;;AAEZ;;AAEA;EACE,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,qCAAqC;EACrC,uCAAuC;EACvC,8BAA8B;EAC9B,kCAAkC;EAClC,+BAA+B;EAC/B,oBAAoB;EACpB,qBAAqB;EACrB,aAAa;EACb,4BAA4B;EAC5B,gBAAgB;AAClB;AACA,gEAAgE;;AAEhE;EACE,OAAO,6BAA6B,EAAE;EACtC,OAAO,6BAA6B,EAAE;AACxC;;AAEA;EACE;;;;;GAKC;EACD,2BAA2B;EAC3B,sEAAsE;EACtE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB","sourcesContent":["/* ── Card shell ───────────────────────────────────────────── */\n\n.scl--cms-components-notifTable-card {\n  box-sizing: border-box;\n  width: 100%;\n  min-height: 100%;\n  background: var(--neutralcolors-100);\n  border: 1px solid var(--neutralcolors-300);\n  box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.04);\n  border-radius: 5px;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  min-width: 0;\n}\n\n/* ── Header ───────────────────────────────────────────────── */\n\n.scl--cms-components-notifTable-header {\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  padding: 16px 24px;\n  height: 56px;\n  background: var(--neutralcolors-100);\n  border-bottom: 1px solid var(--neutralcolors-300);\n  flex-shrink: 0;\n}\n\n.scl--cms-components-notifTable-title {\n  background: none;\n  border: none;\n  padding: 5px 20px 5px 0px;\n  cursor: pointer;\n  font-family: var(--font-family-inter);\n  font-weight: 600;\n  font-size: var(--font-size-18);\n  line-height: var(--line-height-24);\n  letter-spacing: var(--letter-spacing-6);\n  color: var(--typography-text-body-primary);\n  text-align: left;\n}\n\n.scl--cms-components-notifTable-title:hover {\n  text-decoration: underline;\n}\n\n.scl--cms-components-notifTable-seeMore {\n  font-family: var(--font-family-inter);\n  font-weight: var(--font-weight-regular);\n  font-size: var(--font-size-14);\n  line-height: var(--line-height-20);\n  letter-spacing: var(--letter-spacing-4);\n  color: var(--primarypalette-blue);\n  text-decoration: none;\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n\n.scl--cms-components-notifTable-seeMore:hover {\n  text-decoration: underline;\n}\n\n/* ── Column headers ───────────────────────────────────────── */\n\n.scl--cms-components-notifTable-thead {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  background: var(--neutralcolors-200);\n  border-bottom: 1px solid var(--neutralcolors-300);\n  height: 34px;\n  flex-shrink: 0;\n}\n\n.scl--cms-components-notifTable-th {\n  font-family: var(--font-family-inter);\n  font-weight: 500;\n  font-size: var(--font-size-16);\n  line-height: var(--line-height-18);\n  letter-spacing: var(--letter-spacing-4);\n  color: var(--neutralcolors-600);\n  padding: 0 24px;\n}\n\n.scl--cms-components-notifTable-th--date {\n  width: 145px;\n  flex-shrink: 0;\n}\n\n/* ── Body ─────────────────────────────────────────────────── */\n\n.scl--cms-components-notifTable-body {\n  height: 362.5px;\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  overflow-y: hidden;\n}\n\n/* ── Row ─────────────────────────────────────────────────── */\n\n.scl--cms-components-notifTable-row {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  width: 100%;\n  min-height: 80px;\n  border-bottom: 1px solid var(--neutralcolors-300);\n  box-sizing: border-box;\n}\n\n.scl--cms-components-notifTable-row:last-child {\n  border-bottom: none;\n}\n\n.scl--cms-components-notifTable-row:hover {\n  background: var(--action-hover);\n}\n\n/* ── Cells ───────────────────────────────────────────────── */\n\n.scl--cms-components-notifTable-cell {\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  height: 100%;\n}\n\n.scl--cms-components-notifTable-cell--date {\n  width: 145px;\n  flex-shrink: 0;\n  padding: 12px 24px;\n}\n\n.scl--cms-components-notifTable-cell--desc {\n  flex: 1;\n  padding: 12px 24px;\n  min-width: 0;\n}\n\n/* ── Date text ───────────────────────────────────────────── */\n\n.scl--cms-components-notifTable-date {\n  font-family: var(--font-family-inter);\n  font-weight: var(--font-weight-regular);\n  font-size: var(--font-size-16);\n  line-height: var(--line-height-30);\n  color: var(--neutralcolors-600);\n  white-space: nowrap;\n}\n\n/* ── Notification text ───────────────────────────────────── */\n\n.scl--cms-components-notifTable-text {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  gap: 5px;\n  flex: 1;\n  min-width: 0;\n}\n\n.scl--cms-components-notifTable-notifTitle {\n  background: transparent;\n  border: none;\n  display: flex;\n\n  font-family: var(--font-family-inter);\n  font-weight: 500;\n  font-size: var(--font-size-16);\n  line-height: var(--line-height-20);\n  color: var(--neutralcolors-800);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  transition: all 0.3s ease;\n  padding: 0;\n\n}\n\n.scl--cms-components-notifTable-notifTitle:hover {\n  text-decoration: underline;\n  cursor: pointer;\n}\n\n.scl--cms-components-notifTable-notifDesc {\n  font-family: var(--font-family-inter);\n  font-weight: var(--font-weight-regular);\n  font-size: var(--font-size-12);\n  line-height: var(--line-height-18);\n  color: var(--neutralcolors-600);\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n/* ── Skeleton loader ──────────────────────────────────────── */\n\n@keyframes scl--cms-components-notifTable-shimmer {\n  0%   { background-position: -600px 0; }\n  100% { background-position:  600px 0; }\n}\n\n.scl--cms-components-notifTable-skeleton {\n  background: linear-gradient(\n    90deg,\n    var(--neutralcolors-200) 25%,\n    var(--neutralcolors-300) 50%,\n    var(--neutralcolors-200) 75%\n  );\n  background-size: 600px 100%;\n  animation: scl--cms-components-notifTable-shimmer 1.4s infinite linear;\n  border-radius: 4px;\n}\n\n.scl--cms-components-notifTable-skeleton--title {\n  width: 110px;\n  height: 18px;\n}\n\n.scl--cms-components-notifTable-skeleton--link {\n  width: 56px;\n  height: 14px;\n}\n\n.scl--cms-components-notifTable-skeleton--th {\n  height: 12px;\n  border-radius: 3px;\n}\n\n.scl--cms-components-notifTable-skeleton--date {\n  width: 72px;\n  height: 14px;\n}\n\n.scl--cms-components-notifTable-skeleton--row-title {\n  height: 14px;\n  margin-bottom: 8px;\n}\n\n.scl--cms-components-notifTable-skeleton--row-desc {\n  height: 12px;\n  border-radius: 3px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
